module.exports = __webpack_public_path__ + "img/money.ec342a82.svg";